<template>
    <v-card class="w100p round-card background-2" elevation="1" v-if="!loading">
        <v-card-title class="pa-3">
            <p class="pl-2 pl-xl-3">Prodotti a disposizione</p>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
            <template v-for="(product, p) in products" >
                <v-card-text :key="p" class="pt-4">
                    <v-card-title class="pa-0">
                    <div class="pl-2 font-weight-bold" style="font-size: 13px; line-height: normal;">
                        <div class="pb-1">
                            {{ product.code }}
                        </div>
                        <div class="pb-2">
                            {{ product.name }}
                        </div>
                    </div>
                    </v-card-title>                    
                    <div class="d-flex">
                        <v-chip label :ripple="true" color="error" class="mx-2 pa-5" @click="decrement(product, p)" :disabled="product.quantity == 0">
                            <v-icon size="18">
                                remove
                            </v-icon>
                        </v-chip>
                        <v-text-field
                            v-model.number="product.quantity"
                            type="number"
                            class="interventonvalue"
                            outlined
                            dense
                            @change="updateParent($event, p)">
                        </v-text-field>
                        <v-text-field
                            style="max-width: 100px"
                            v-model.number="product.available_quantity"
                            type="number"
                            class="interventonvalue"
                            outlined
                            persistent-hint
                            hint="Max"
                            disabled
                            dense>
                        </v-text-field>
                        <v-chip label :ripple="true" color="success" class="mx-2 pa-5" @click="increment(product, p)" :disabled="product.quantity == product.available_quantity">
                            <v-icon>
                                add
                            </v-icon>
                        </v-chip>
                    </div>
                </v-card-text>
            </template>
    </v-card>
</template>

<script>
export default {
	name: 'intervention-product-list',
    props: {
        id: Number,
        parent: Object,
        infoUrl: String,
    },
    data() {
        return {
            products: [],
            loading: true
        }
    },

    methods: {
        initialize() {
            this.axios.get('troubles/' + this.parent.timecardable_id + '/availableproducts/' + (this.parent.id ? this.parent.id : '')).then(response => {
                
                this.products = response.data.products
                this.loading = false

            }, response => {
                // error callback
            })
        },

        decrement(product, p) {
            if(product.quantity != 0) {
                product.quantity -= 1
                this.$set(this.parent, 'interventionproducttrouble', this.products)
            }
        },
        
        increment(product, p) {
            if(product.quantity < product.available_quantity) {
                product.quantity += 1
                this.$set(this.parent, 'interventionproducttrouble', this.products)
             }
        },

        updateParent(data, p) {
            if(data > this.products[p].available_quantity) {
                this.products[p].quantity = this.products[p].available_quantity
            }
            this.$set(this.parent, 'interventionproducttrouble', this.products)
        }
    },

    created() {
        this.initialize()
    },
}
</script>

<style>
 .interventonvalue .v-text-field__slot input {
     text-align: center;
     font-weight: bold !important;
 }
</style>